import { render, staticRenderFns } from "./UserLogout.vue?vue&type=template&id=49ef3e1e&"
import script from "./UserLogout.vue?vue&type=script&lang=js&"
export * from "./UserLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ef3e1e')) {
      api.createRecord('49ef3e1e', component.options)
    } else {
      api.reload('49ef3e1e', component.options)
    }
    module.hot.accept("./UserLogout.vue?vue&type=template&id=49ef3e1e&", function () {
      api.rerender('49ef3e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/UserLogout.vue"
export default component.exports